import { render } from "./AppointmentViewModal.vue?vue&type=template&id=dff21f8a&scoped=true"
import script from "./AppointmentViewModal.vue?vue&type=script&lang=js"
export * from "./AppointmentViewModal.vue?vue&type=script&lang=js"

import "./AppointmentViewModal.vue?vue&type=style&index=0&id=dff21f8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dff21f8a"]])

export default __exports__